export const selectUserInfoById = id => state => state.users.usersInfo?.[id] || null;
